exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".composer textarea[data-v-f1c9747a] {\n  width: 96%;\n  resize: none;\n}[dir] .composer textarea[data-v-f1c9747a] {\n  margin: 10px;\n  border-radius: 3px;\n  border: 1px solid lightgray;\n  padding: 6px;\n}", ""]);

// exports
